import * as actions from "../constants/actionTypes";
export const INITIAL_STATE = {
    allCountryList: [],
    countryList: [],
    provinceList: [],
    cityList: [],
    redirectURL: "",
    searchCountryText: "",
    filterContestList: [],
    deselectedList: [],
};
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actions.COUNTRY_LIST_SUCCESS:
            // const { name } = action.payload;
            return {
                ...state,
                countryList: action.payload,
                allCountryList: action.payload,
            }

        case actions.SEARCH_COUNTRY_LIST:
            const { allCountryList } = state;
            const countryList = allCountryList.filter(item => {
                const { name } = item;
                return (
                    name.toLowerCase().indexOf(action.payload.trim().toLowerCase()) > -1
                );
            });
            if (countryList.length == 0) {
                countryList.push(
                    {
                        alpha2Code: null,
                        alpha3Code: null,
                        callingCodes: null,
                        flag: null,
                        latlng: null,
                        name: "NOT FOUND",
                        timezones: null,
                        __v: null,
                        _id: null,
                    }
                )
            }
            return {
                ...state,
                countryList,
                searchCountryText: action.payload.trim()
            }

        case actions.PROVINCE_LIST_SUCCESS:
            return {
                ...state,
                provinceList: action.payload,
                cityList: []
            }

        case actions.CITY_LIST_SUCCESS:
            return {
                ...state,
                cityList: action.payload
            }

        case actions.CHANGE_REDIRECT_URL:
            return {
                ...state,
                redirectURL: action.payload,
            }

        case actions.GET_FILTER_LIST_DATA_SUCCESS:
            let { contestList, userContestFilter, userConutry } = action.payload;
            let userContestFilterList;
            if(userContestFilter == 'global') {
                userContestFilterList = [];
                contestList.map(category => {
                    let contest = category.contest.map(item => {
                        if(category._id == 'GLOBAL' || category._id == userConutry) {
                            item.isSelected = true;
                        } else {
                            item.isSelected = false;
                            userContestFilterList.push(item.name)
                        }
                        return item;
                    });
                    category.contest = contest;
                    category.isSelected = contest.filter(item => item.isSelected == true).length ? true : false;
                    return category;
                })
            } else {
                userContestFilterList = userContestFilter.split(',')
                contestList.map(category => {
                    let contest = category.contest.map(item => {
                        item.isSelected = userContestFilterList.includes(item.name) ? false : true;
                        return item;
                    });
                    category.contest = contest;
                    category.isSelected = contest.filter(item => item.isSelected == true).length ? true : false;
                    return category;
                })
            }
            return {
                ...state,
                filterContestList: contestList,
                deselectedList: userContestFilterList,
            }

        case actions.FILTER_LIST_DATA:
            const { category, contest, categoryFlag, contestFlag } = action.payload;
            let { filterContestList, deselectedList } = state;
            filterContestList = filterContestList.map(categori => {
                let contests = [];
                if(contest == null) {
                    if(categori._id == category) {
                        contests = categori.contest.map(item => {
                            item.isSelected = !categoryFlag;
                            return item;
                        });
                        categori.contest = contests;
                        categori.isSelected = !categoryFlag;
                    }
                    return categori;
                } else {
                    if(categori._id == category) {
                        contests = categori.contest.map(item => {
                            if(item.name == contest) {
                                item.isSelected = !contestFlag;
                            }
                            return item;
                        });
                        let isSelected = contests.filter(item => item.isSelected == true).length > 0;
                        categori.contest = contests;
                        categori.isSelected = isSelected;
                    }
                    return categori;
                }
            });
            // if(deselectedList.filter(item => item.category == category && item.contest == contest).length == 0){
            //     deselectedList.push({category, contest});
            // } else {
            //     deselectedList = deselectedList.filter(item => item.category != category && item.contest != contest);
            // }
            if(contest != null) {
                if(deselectedList.includes(contest)){
                    deselectedList = deselectedList.filter(item => item != contest);
                } else {
                    deselectedList.push(contest);
                }
            } else {
                let categoryData = filterContestList.filter(item => item._id == category)[0];
                if(!categoryData.isSelected) {
                    categoryData.contest.map(item => {
                        if(!deselectedList.includes(item.name)) {
                            deselectedList.push(item.name);
                        }
                    })
                } else {
                    categoryData.contest.map(item => {
                        let index = deselectedList.indexOf(item.name);
                        if(index > -1) {
                            deselectedList.splice(index, 1);
                        }
                    })
                }
            }
            return {
                ...state,
                filterContestList,
                deselectedList
            }

        case actions.RESET_FILTER_LIST_DATA:
            let list = state.filterContestList;
            list.map(category => {
                let contest = category.contest.map(item => {
                    item.isSelected = true;
                    return item;
                });
                category.contest = contest;
                category.isSelected = true;
                return category;
            })
            return {
                ...state,
                filterContestList: list
            }
        
        default:
            return state;
    }
};
